<template>
  <div ref="page" class="job-desc">
    <div v-if="jobDescData" class="">
      <div class="job-title-wrap">
        <div class="job-title">
          <h3>{{ jobDesc.Name }}</h3>
          <p>{{ jobDesc.Type }} | {{ jobDesc.WorkPlace }}</p>
        </div>
        <div v-if="jobDesc.WechatUrl" class="wechat-qr">
          <vue-qr
            :text="jobDesc.WechatUrl"
            :logoSrc="wechatIconUrl"
            :logoScale="0.33"
            :correctLevel="3"
            :size="80"
            :dotScale="1"
            :margin="0"
          ></vue-qr>
          <div style="text-align: center">微信咨询</div>
        </div>
        <div class="job-button-wrap top-button">
          <el-button size="default" type="primary" @click="jobApply"
            >申请职位</el-button
          >
        </div>
      </div>
      <h4 class="sub-title">职位描述</h4>
      <div class="job-content" v-html="jobDesc.Description"></div>
      <h4 class="sub-title">学历要求</h4>
      <div class="job-sub">
        <p>{{ jobDesc.RequireEducation }}</p>
      </div>
      <h4 class="sub-title">公司介绍</h4>
      <div class="job-cmp">
        <p style="margin-bottom: 10px">深圳市云伽智能技术有限公司</p>
        <p>
          云伽智能是以汽车智能诊断、车联网&物联网智能硬件、云平台、解决方案为核心业务的高新技术企业，旗下拥有汽车智能诊断品牌XTOOL、车联网&物联网业务品牌IN+。拥有从产品设计、研发、生产、交付的闭环体系保障。公司每年在研发领域大量投入，技术人才占比全员54%，并建立智能研发实验室。此外，云伽智能拥有现代化生产基地，引入先进的国际供应链体系及5大标准测试环节，多年来及时稳定的交付能力得到了客户的高度赞誉。
        </p>
        <p>
          云伽智能海外业务已覆盖全球70多个国家和地区、国内业务覆盖全国31个省市，为戴姆勒、中兴、腾讯、阿里、滴滴、摩拜、瑞幸、博世、北京汽车、上汽通用、一汽大众、东风小康、奇瑞汽车、福田汽车等客户服务。云伽智能致力于成为国内领先的汽车智能诊断、车联网、物联网解决方案供应商企业。
        </p>
      </div>
      <div class="job-button-wrap center">
        <el-button size="default" type="primary" @click="jobApply"
          >申请职位</el-button
        >
      </div>
    </div>
    <div v-else-if="isLoaded" class="job-desc-empty">
      <i class="el-icon-warning-outline" style="color: #e6a23c"></i>
      很抱歉，该职位已撤销或不存在(id={{ this.$route.query.jobid }})
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
import wechatIconUrl from '../assets/images/wechatIcon.png'
export default {
  name: 'job-desc',
  components: { VueQr },
  data() {
    return {
      jobDescData: null,
      isLoaded: false,
      wechatIconUrl: wechatIconUrl,
    }
  },
  computed: {
    jobDesc() {
      return this.jobDescData || {}
    },
    fromGroup() {
      return this.$route.query.fromGroup
    },
  },
  mounted() {
    this.setIframeHeight()
  },
  created() {
    this.getJobDesc(this.$route.query.jobid)
  },
  methods: {
    setIframeHeight() {
      this.$nextTick(() => {
        window.parent.postMessage(
          {
            callback: 'setIframeHeight',
            args: [this.$refs.page.scrollHeight + 50],
          },
          '*'
        )
      })
    },
    jobApply() {
      let fromGroup = this.$route.query.fromGroup
      // console.log('jobApply--fromGroup', fromGroup)
      let pageName = fromGroup == 'social' ? 'SocialJobApply' : 'JobApply'
      this.$router.push({
        name: pageName,
        query: {
          jobid: this.$route.query.jobid,
          Name: this.jobDesc.Name,
          Type: this.jobDesc.Type,
          WorkPlace: this.jobDesc.WorkPlace,
          WechatUrl: this.jobDesc.WechatUrl,
        },
      })
    },
    getJobDesc(jobid) {
      this.$apiGet('/recruit/getJobDesc', { jobid })
        .then((data) => {
          this.isLoaded = true
          this.jobDescData = data
          this.setIframeHeight()
        })
        .catch((error) => {
          this.isLoaded = true
          if (this.$isServerFail(error)) {
            console.error(error)
          }
        })
    },
  },
}
</script>
<style lang="less">
.job-desc {
  padding: 4% 4% 5%;
  box-sizing: border-box;
  .job-title-wrap {
    margin-bottom: 8%;
    .job-title {
      h3 {
        margin: 0 0 12px;
        font-size: 26px;
        color: #1b1b1b;
      }
      p {
        font-size: 16px;
        margin: 0;
        color: #646464;
      }
    }
    .wechat-qr {
      padding-top: 4%;
    }
  }
  .sub-title {
    margin: 0 0 2%;
    font-size: 18px;
    color: #1b1b1b;
  }
  .job-content {
    color: #646464;
    font-size: 16px;
    margin-bottom: 6%;
    p {
      margin-block-start: 0.6em;
      margin-block-end: 0.6em;
    }
  }
  .job-sub {
    margin-bottom: 6%;
    font-size: 16px;
    span {
      color: #646464;
    }
    p {
      margin-block-start: 0.6em;
      margin-block-end: 0.6em;
    }
  }
  .job-cmp {
    padding-bottom: 6%;
    p {
      color: #646464;
      margin: 0;
      line-height: 21px;
      font-size: 13px;
    }
  }
  .job-button-wrap {
    &.top-button {
      display: none;
    }
    &.center {
      text-align: center;
    }
  }
  .el-button--primary {
    background-color: #028be6;
    border-color: #028be6;
  }
  .job-desc-empty {
    padding-top: 10%;
    padding-bottom: 10%;
    text-align: center;
    font-size: 16px;
    color: #646464;
  }
}
@media (min-width: 768px) {
  .job-desc {
    background-color: #fff;
    padding: 3% 3% 5%;
    width: 80%;
    margin: 0 auto;
    box-sizing: border-box;
    .job-title-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0;

      .job-title {
        h3 {
          margin: 0 0 12px;
          font-size: 32px;
          color: #1b1b1b;
        }
        p {
          font-size: 16px;
          margin: 0;
          color: #646464;
        }
      }
    }
    .sub-title {
      margin: 0 0 2%;
      font-size: 18px;
      color: #1b1b1b;
    }
    .job-content {
      color: #646464;
      font-size: 16px;
      margin-bottom: 6%;
      p {
        margin-block-start: 0.6em;
        margin-block-end: 0.6em;
      }
    }
    .job-sub {
      margin-bottom: 6%;
      font-size: 16px;
      span {
        color: #646464;
      }
      p {
        margin-block-start: 0.6em;
        margin-block-end: 0.6em;
      }
    }
    .job-cmp {
      padding-bottom: 6%;
      p {
        color: #646464;
        margin: 0;
        line-height: 21px;
        font-size: 13px;
      }
    }
    .job-button-wrap {
      &.top-button {
        display: block;
      }
      &.center {
        text-align: center;
      }
    }
  }
}
</style>
